import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type MoonIconProps = CommonSvgProps

const MoonIcon: React.FC<MoonIconProps> = React.forwardRef<SVGSVGElement, MoonIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 24 24" {...props} ref={ref} color="none">
      <path
        d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
        fill="#D4D4D4"
      />
      <path
        d="M7 8a2.333 2.333 0 1 0 0-4.667A2.333 2.333 0 0 0 7 8ZM13.332 12.667a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM14.331 20.667a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667ZM14 5.333a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666ZM1.999 12.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334ZM19.999 6.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334ZM9.999 21.333a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM21.331 14a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667ZM6.665 16.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667Z"
        fill="#B2B2B2"
      />
    </Svg>
  )
)

MoonIcon.propTypes = commonPropTypes
MoonIcon.defaultProps = commonDefaultProps

export default MoonIcon
